import { AxiosResponse } from 'axios';
import { DataTransfer } from '@esmiley/frontend-core';
import * as errorDispatch from 'redux/ducks/error';
import { API_DATE_FORMAT } from 'utils/datetime';
import moment, { Moment } from 'moment';
import { CreateSale, SalesActionTypes, Sale, SalesActions, SalesState } from './types';
import { ErrorActions } from 'redux/ducks/error/types';
import { ThunkResult } from 'redux/types';

export * from './types';

export const initialState: SalesState = {
  sales: [],
  yearlySales: [],
  lastSale: undefined
};

export default function reducer(
  state: SalesState = initialState,
  action: SalesActions
): SalesState {
  switch (action.type) {
    case SalesActionTypes.SUBMIT_SALES:
      return { ...state, lastSale: action.payload, sales: [...state.sales, action.payload] };

    case SalesActionTypes.GET_SALES:
      return { ...state, sales: action.payload };

    case SalesActionTypes.GET_YEARLY_SALES:
      return { ...state, yearlySales: action.payload };
    default:
      return state;
  }
}

const transfer = new DataTransfer();

interface SaleOptions {
  start?: Moment;
  end?: Moment;
}

export function getSales(
  options: SaleOptions = {}
): ThunkResult<Promise<SalesActions | ErrorActions>, SalesActions | ErrorActions> {
  return async (dispatch) => {
    const start = options.start && options.start.format(API_DATE_FORMAT);
    const end = options.end && options.end.format(API_DATE_FORMAT);
    const params = Object.assign({}, start && { start }, end && { end });

    try {
      const response = (await transfer.get('/foodwaste/sales', {
        params
      })) as AxiosResponse<Sale[]>;
      return dispatch({
        type: SalesActionTypes.GET_SALES,
        payload: response.data
      });
    } catch (error: unknown) {
      return dispatch(errorDispatch.displayError(error as Error));
    }
  };
}

export function getYearlySales(): ThunkResult<
  Promise<SalesActions | ErrorActions>,
  SalesActions | ErrorActions
> {
  return async (dispatch) => {
    // Fetch sales from one year back
    const startOfMonth: Moment = moment().startOf('month');
    const start = startOfMonth.subtract(12, 'month').format(API_DATE_FORMAT);
    const end = moment().format(API_DATE_FORMAT);
    const params = Object.assign({}, { start }, { end });

    try {
      const response = (await transfer.get('/foodwaste/sales', {
        params
      })) as AxiosResponse<Sale[]>;
      return dispatch({
        type: SalesActionTypes.GET_YEARLY_SALES,
        payload: response.data
      });
    } catch (error: unknown) {
      return dispatch(errorDispatch.displayError(error as Error));
    }
  };
}

export function submitSales(
  data: CreateSale
): ThunkResult<Promise<SalesActions | ErrorActions>, SalesActions | ErrorActions> {
  return async (dispatch) => {
    if (!data.date) {
      try {
        const response = (await transfer.post('/foodwaste/sales', data)) as AxiosResponse<Sale>;
        return dispatch({
          type: SalesActionTypes.SUBMIT_SALES,
          payload: response.data
        });
      } catch (error: unknown) {
        return dispatch(errorDispatch.displayError(error as Error));
      }
    }

    // TODO Change this when the service-foodwaste is fixed so it dosen't make more than 1 sales registration per date
    // Delete all sales registrations at the given date and then create a new sales registration at the date
    const params = { date: data.date };
    try {
      await transfer.delete('/foodwaste/sales', { params });
      const response = (await transfer.post('/foodwaste/sales', data)) as AxiosResponse<Sale>;
      return dispatch({
        type: SalesActionTypes.SUBMIT_SALES,
        payload: response.data
      });
    } catch (error: unknown) {
      return dispatch(errorDispatch.displayError(error as Error));
    }
  };
}
